import React, { createContext, useContext, useMemo, useState } from 'react';

const IconsContext = createContext(null);

export const IconsProvider = ({ children }) => {
  const [iconsByKey, setIconsByKey] = useState(null);

  const value = useMemo(() => ({
    iconsByKey,
    setIconsByKey,
  }), [iconsByKey]);

  return (
    <IconsContext.Provider value={value}>
      {children}
    </IconsContext.Provider>
  );
};

export const useIcons = () => {
  const context = useContext(IconsContext);
  if (!context) {
    throw new Error('useIcons must be used within IconsProvider');
  }
  return context;
};

export default IconsContext;
